<template>
  <d-card-body class="pt-0">
    <div class="card-body p-0 pb-3 text-center mtop responsive-table">
      <table class="table mb-0 mr-4" style="border: 1px #dee2e6 solid;table-layout: fixed;">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0">Klient</th>
            <th scope="col" class="border-0">Spółka</th>
            <th scope="col" class="border-0">Zabezpieczenia</th>
            <th scope="col" class="border-0">Pozostało do spłaty</th>
            <th scope="col" class="border-0">Akcja</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="schedule in schedules">
            <td>
              <dt>Klient</dt>
              <dd>
                <router-link :to="`/klienci/edycja/${parseInt(schedule.client_id, 10)}`">
                  {{ schedule.client_name }} {{ schedule.client_last_name }}
                </router-link>
              </dd>
            </td>
            <td>
              <dt>Spółka</dt>
              <dd>{{ schedule.company_name }}</dd>
            </td>
            <td>
              <dt>Zabezpieczenia</dt>
              <dd>
                <span class="wsnw"><strong>Z wpisem:</strong>
                    <span class="ml-2"
                          :class="{ 'text-success': schedule.payment_guarantees_with_excerpt_received  > 0 && schedule.payment_guarantees_with_excerpt_received  === schedule.payment_guarantees_number }">
                        {{ schedule.payment_guarantees_with_excerpt_received }}/{{ schedule.payment_guarantees_number }}
                    </span>
                </span><br>
              </dd>
            </td>
            <td class="cell-penalty">
              <dt>Pozostało do spłaty</dt>
              <dd>{{ toNumber(schedule.to_finish_credit) }} zł</dd>
            </td>
            <td>
              <dt>Akcja</dt>
              <router-link
                class="btn btn-primary"
                :to="`/klienci/edycja/${parseInt(schedule.client_id, 10)}/${parseInt(schedule.id, 10)}`">
                <i class="material-icons">edit</i> Edytuj
              </router-link>
            </td>
          </tr>
          <tr v-if="!schedules.length">
            <td colspan="5" class="text-center text-info">
              Brak umów do wyświetlenia&hellip;
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </d-card-body>
</template>

<script>
  import SsDate from '../common/SsDate'

export default {
  name: 'guaranteesToUpdate',
  components: {
    SsDate
  },
  props: {
    props: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      schedules: []
    };
  },
  methods: {
    toNumber (number) {
      return Vue.toNumber(number);
    },
    fetchData () {
      this.$emit('updateData');
    }
  },
  mounted () {
    this.schedules = this.props;
  },
  watch: {
    props: {
      handler: function(to) {
        this.schedules = to;
      },
      deep: true
    },
  }
};
</script>

<style>
  .mtop{
    margin-top: 15px;
  }
</style>
